import { ReactNode } from 'react';
import { createSearchParams, Navigate, useLocation } from 'react-router-dom';

import useAuth from '@hooks/useAuth';

import { LOGIN_PATH } from '@routes/router';

export default function PrivateRoute({ element }: { element: ReactNode }) {
  const location = useLocation();

  const { isAuthenticated } = useAuth();

  const returnTo = `${location.pathname}${location.search}`;

  return isAuthenticated ? (
    element
  ) : (
    <Navigate
      to={{
        pathname: LOGIN_PATH,
        search: createSearchParams({ r: returnTo }).toString(),
      }}
      replace
    />
  );
}
